module.exports = __webpack_public_path__ + "media/img/footer/footer-bg-eeea05f6cb69f6ff895892071a95b9dc.svg";